import script from "./PaymentSlip.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentSlip.vue?vue&type=script&setup=true&lang=js"

import "./PaymentSlip.vue?vue&type=style&index=0&id=5b52a98a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b52a98a"]])

export default __exports__